import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, shareReplay, catchError, map } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PlatformCompanyLogoService {
  private readonly http = inject(HttpClient);
  private readonly cache = new Map<number, Observable<string | null>>();

  /**
   * Returns a cached object-URL for a company logo, or null when unavailable.
   * @param companyId - Company id
   * @returns Observable of logo object URL or null
   */
  logoUrl(companyId: number): Observable<string | null> {
    const cached = this.cache.get(companyId);
    if (cached) {
      return cached;
    }
    const request$ = this.http
      .get(`${environment.apiBaseUrl}/general/companies/${companyId}/logo`, {
        responseType: 'blob',
      })
      .pipe(
        map((blob) => {
          if (!blob || blob.size === 0) {
            return null;
          }
          return URL.createObjectURL(blob);
        }),
        catchError(() => of(null)),
        shareReplay(1)
      );
    this.cache.set(companyId, request$);
    return request$;
  }
}
